/**
 * Upload API tab for the collection page.
 *
 * Thin container that renders the Upload API documentation: how to upload files
 * (with per-file custom fields) via the platform-api multipart flow, authenticated
 * with a user-scoped Personal API token (PAT). Mirrors the external-chat tab's
 * API-docs presentation.
 */

import { UploadApiDocsSection } from './api-docs-section';

interface UploadApiTabProps {
  orgId: string;
  collectionId: string;
  /** Field names this collection lets callers override per file
   *  (collection.exposed_upload_attributes). */
  exposedAttributes?: string[];
}

export const UploadApiTab = ({
  orgId,
  collectionId,
  exposedAttributes,
}: UploadApiTabProps) => {
  return (
    <UploadApiDocsSection
      orgId={orgId}
      collectionId={collectionId}
      exposedAttributes={exposedAttributes}
    />
  );
};
